import React from 'react'
import NavigationBar from './NavigationBar'
import { Container } from 'react-bootstrap'
import Footer from './Footer'

export default function PrivacyPolicy() {
    return (
        <div>
            <NavigationBar />
            <Container>
                <h1 style={{
                    marginTop: "3rem"
                }}>Privacy Policy</h1>
                <p>
                    At Diaba Market Place , we value the trust of our users, partners, and merchants. This Privacy Policy explains how we collect, use, and protect your personal data when you interact with us through our website, mobile application, or other communication channels.
                </p>
                <p>
                    Our services include connecting buyers and sellers, order management, payment solutions, and logistics services.
                </p>
                <h1>
                    Contact details
                </h1>
                <p>
                    Email :  contact@diaba.store
                </p>
                <p>
                    Telephone : +221 77 411 51 64
                </p>
                <h1>
                    What personal data do we collect?
                </h1>
                <p>
                    We may collect the following information when you use Diaba Market Place :
                </p>
                <ul>
                    <li>
                        Name, surname and contact details
                    </li>
                    <li>
                        Company name (for sellers)
                    </li>
                    <li>
                        Delivery and billing address
                    </li>
                    <li>
                        Phone number
                    </li>
                    <li>
                        E-mail address
                    </li>
                    <li>
                        Payment information (via our secure providers)
                    </li>
                    <li>
                        Order details and product preferences
                    </li>
                    <li>
                        IP address, browser type, information about the device used
                    </li>
                </ul>



                <h1>
                    How do we use your data?
                </h1>
                <p>We use your personal data in order to:</p>
                <ul>
                    <li>
                        Process your orders and ensure delivery.
                    </li>
                    <li>
                        Manage your user account and preferences.
                    </li>
                    <li>
                        Facilitating connections between buyers and sellers.
                    </li>
                    <li>
                        Facilitating secure payments.
                    </li>
                    <li>
                        Improve our services, our website and our application.
                    </li>
                    <li>
                        Communicating about offers, new products or promotions (if you consent).
                    </li>
                    <li>
                        Comply with our legal and regulatory obligations.
                    </li>

                </ul>

                <h1>
                    Cookies and website analytics

                </h1>
                <p>
                    Our website and app use cookies and analytics tools to understand user behavior and improve performance. You can manage your cookie preferences through your browser settings.
                </p>

                <h1>
                    Data sharing
                </h1>
                <p>
                    We do not sell or rent your personal data. Your information may only be shared with:
                </p>
                <ul>
                    <li>
                        Our technical service providers (hosting, payment, logistics).
                    </li>
                    <li>
                        The sellers or merchants from whom you place your order.
                    </li>
                    <li>
                        The competent authorities if required by law.
                    </li>
                    <li>
                        All our partners are required to respect the confidentiality and security of your data.
                    </li>
                </ul>

                <h1>
                    International data transfer
                </h1>
                <p>
                    Since Diaba Market Place operates with international partners (China, Dubai, etc.), your information may be transferred and processed outside your country of residence. We implement appropriate safeguards to protect your data in accordance with applicable laws.
                </p>
                <h1>
                    Shelf life
                </h1>
                <p>
                    Your data is kept for as long as necessary to fulfill our commercial, contractual, and legal obligations. When it is no longer needed, it will be deleted or anonymized.
                </p>

                <h1>
                    Your rights
                </h1>
                <p>
                    In accordance with data protection laws, you have the right to:
                </p>
                <ul>
                    <li>
                        Request access to the personal data we hold about you.
                    </li>
                    <li>
                        Request that your information be corrected if it is inaccurate.
                    </li>
                    <li>
                        Request the deletion of your data (subject to legal or contractual obligations).
                    </li>
                    <li>
                        Withdraw your consent for marketing communications.
                    </li>
                    <li>
                        To exercise your rights, please contact us at  contact@diaba.store
                    </li>
                </ul>
                <h1>
                    Privacy Policy Update
                </h1>
                <p>
                    We may update this Privacy Policy to reflect legal, regulatory, or technical changes. Any updates will be posted on this page with the effective date.
                </p>

            </Container>
            <Footer />
        </div>
    )
}
